export default {
  dataNotAvailable: 'Data tidak tersedia'
}